export default __webpack_public_path__ + "static/media/video-image-2.b7f227a3.png";